import { MENU_JIAMENG_GOODS, JIAMENG_GOODS_PATH } from '@constant'

export default {
  key: MENU_JIAMENG_GOODS,
  id: '',
  title: '商品',
  icon: 'icon-shangpin',
  link: JIAMENG_GOODS_PATH
}
